import React from 'react';
import LayoutInput from 'components/forms/layoutInput';
import Col from 'components/Col';
import ValidationGroup from 'helpers/validation';
import PropTypes from 'prop-types';
import {inRange} from './helpers';
import {injectIntl, intlShape} from 'react-intl';

class Kidney extends React.Component {
  static propTypes = {
    group: PropTypes.instanceOf(ValidationGroup).isRequired,
    intl: intlShape,
  };

  static initialState = {
    a: undefined,
    b: undefined,
    length: undefined,
  };

  state = Kidney.initialState;

  update = ({key, value}) => {
    this.setState({[key]: parseFloat(value)});
  };

  volume = averageDepth => {
    return (this.state.a + this.state.b) * this.state.length * averageDepth * 7.5 * 0.45;
  };

  reset = () => {
    this.setState(Kidney.initialState);
  };

  render() {
    const {formatMessage} = this.props.intl;

    return [
      <Col md={4} key='a-col'>
        <LayoutInput type='number'
                     dataKey='a'
                     autoFocus
                     step='0.01'
                     toolTip={formatMessage({id: 'quick-calcs.pool-volume.a.tooltip'})}
                     label={formatMessage({id: 'quick-calcs.pool-volume.a'})}
                     group={this.props.group}
                     validate={inRange}
                     dataChanged={this.update}
                     value={this.state.a}
                     required />
      </Col>,
      <Col md={4} key='b-col'>
        <LayoutInput type='number'
                     dataKey='b'
                     step='0.01'
                     toolTip={formatMessage({id: 'quick-calcs.pool-volume.b.tooltip'})}
                     label={formatMessage({id: 'quick-calcs.pool-volume.b'})}
                     group={this.props.group}
                     validate={inRange}
                     dataChanged={this.update}
                     value={this.state.b}
                     required />
      </Col>,
      <Col md={4} key='length-col'>
        <LayoutInput type='number'
                     dataKey='length'
                     step='0.01'
                     group={this.props.group}
                     toolTip={formatMessage({id: 'quick-calcs.pool-volume.length.tooltip'})}
                     label={formatMessage({id: 'quick-calcs.pool-volume.length'})}
                     validate={inRange}
                     dataChanged={this.update}
                     value={this.state.length}
                     required />
      </Col>,
    ];
  }
}

export default injectIntl(Kidney, {withRef: true});
